import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setStatus, setAllStatuses } from 'bundles/apex/deals/show/store/planner_filters/actions';

import PlannerStatusFilters from 'bundles/apex/filters/planner_status_filters';

export function StatusFilters({ plannerFilters, setAllStatuses, setStatus }) {
  return (
    <PlannerStatusFilters
      plannerFilters={plannerFilters}
      setAllStatuses={setAllStatuses}
      setStatus={setStatus}
    />
  );
}

StatusFilters.propTypes = {
  plannerFilters: PropTypes.object.isRequired,
  setAllStatuses: PropTypes.func.isRequired,
  setStatus: PropTypes.func.isRequired,
};

const mapStateToProps = ({ plannerFilters }) => {
  return {
    plannerFilters
  };
};

const mapDispatchToProps = {
  setAllStatuses,
  setStatus
};

export default connect(mapStateToProps, mapDispatchToProps)(StatusFilters);
